module.exports = __webpack_public_path__ + "static/media/noise.212e5db6.mp3";